<template>
  <footer class="main-footer" v-show="!this.$store.state.site.loading" id="oreFooter">
    <div class="container">
    <div class="main-footer__lede">
      <div>
        <p v-html="footerLede"></p>
        <a v-if="footerCtaButton && footerCtaButton.url" :href="footerCtaButton.url" :title="footerCtaButton.title" class="[ btn btn--semi-opaque ]" :target="footerCtaButton.target">{{ footerCtaButton.title || 'Learn more' }}</a>
      </div>
      <svg width="123" height="48" viewBox="0 0 123 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_302_1103)">
        <path d="M122.998 10.3182V1.33984H90.5918V46.2077H122.998V37.2342H99.6228V28.2653H118.965V19.287H99.6228V10.3182H122.998Z" fill="white"/>
        <path d="M23.547 0.376953C10.5635 0.376953 0 10.873 0 23.7737C0 36.6744 10.5635 47.1705 23.547 47.1705C36.5305 47.1705 47.094 36.6744 47.094 23.7737C47.0988 10.873 36.5353 0.376953 23.547 0.376953ZM23.547 38.2016C15.5421 38.2016 9.0312 31.7324 9.0312 23.7785C9.0312 15.8246 15.5421 9.35528 23.547 9.35528C31.5519 9.35528 38.0628 15.8246 38.0628 23.7785C38.0628 31.7324 31.5519 38.2016 23.547 38.2016Z" fill="white"/>
        <path d="M73.8818 28.2332C81.2662 28.2332 87.4238 22.3615 87.61 15.1429C87.7055 11.4813 86.345 8.02372 83.7722 5.40563C81.2042 2.78755 77.7626 1.3457 74.0823 1.3457H49.0508V46.2088H58.082V10.3193H74.0823C75.3043 10.3193 76.4499 10.7983 77.3043 11.671C78.1587 12.5437 78.6122 13.6915 78.5788 14.9104C78.5167 17.3103 76.4069 19.2596 73.877 19.2596H69.8006C66.2683 19.2596 63.1131 21.356 61.7623 24.5955C60.4114 27.8348 61.1465 31.5343 63.643 34.0196L75.9009 46.2136H88.6697L70.5977 28.238H73.877L73.8818 28.2332Z" fill="white"/>
        </g>
        <defs>
        <clipPath id="clip0_302_1103">
        <rect width="123" height="46.7983" fill="white" transform="translate(0 0.376953)"/>
        </clipPath>
        </defs>
      </svg>
    </div>
    <div class="main-footer__col">
      <FooterMenu name="footer-menu" />
      <ul class="main-footer__social">
        <li>
          <a :href="instagramUrl" title="Instagram" target="_blank" rel="noopener noreferrer">
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_302_1081)">
              <path d="M9.5 2.29803C11.903 2.29803 12.188 2.30703 13.1375 2.35053C15.5765 2.46153 16.7157 3.61878 16.8267 6.03978C16.8702 6.98853 16.8785 7.27353 16.8785 9.67653C16.8785 12.0803 16.8695 12.3645 16.8267 13.3133C16.715 15.732 15.5788 16.8915 13.1375 17.0025C12.188 17.046 11.9045 17.055 9.5 17.055C7.097 17.055 6.812 17.046 5.86325 17.0025C3.41825 16.8908 2.285 15.7283 2.174 13.3125C2.1305 12.3638 2.1215 12.0795 2.1215 9.67578C2.1215 7.27278 2.13125 6.98853 2.174 6.03903C2.28575 3.61878 3.422 2.46078 5.86325 2.34978C6.81275 2.30703 7.097 2.29803 9.5 2.29803ZM9.5 0.675781C7.05575 0.675781 6.74975 0.686281 5.78975 0.729781C2.52125 0.879781 0.70475 2.69328 0.55475 5.96478C0.5105 6.92553 0.5 7.23153 0.5 9.67578C0.5 12.12 0.5105 12.4268 0.554 13.3868C0.704 16.6553 2.5175 18.4718 5.789 18.6218C6.74975 18.6653 7.05575 18.6758 9.5 18.6758C11.9443 18.6758 12.251 18.6653 13.211 18.6218C16.4765 18.4718 18.2975 16.6583 18.4452 13.3868C18.4895 12.4268 18.5 12.12 18.5 9.67578C18.5 7.23153 18.4895 6.92553 18.446 5.96553C18.299 2.70003 16.4832 0.880531 13.2118 0.730531C12.251 0.686281 11.9443 0.675781 9.5 0.675781ZM9.5 5.05428C6.94775 5.05428 4.8785 7.12353 4.8785 9.67578C4.8785 12.228 6.94775 14.298 9.5 14.298C12.0522 14.298 14.1215 12.2288 14.1215 9.67578C14.1215 7.12353 12.0522 5.05428 9.5 5.05428ZM9.5 12.6758C7.84325 12.6758 6.5 11.3333 6.5 9.67578C6.5 8.01903 7.84325 6.67578 9.5 6.67578C11.1567 6.67578 12.5 8.01903 12.5 9.67578C12.5 11.3333 11.1567 12.6758 9.5 12.6758ZM14.3045 3.79203C13.7075 3.79203 13.2238 4.27578 13.2238 4.87203C13.2238 5.46828 13.7075 5.95203 14.3045 5.95203C14.9008 5.95203 15.3837 5.46828 15.3837 4.87203C15.3837 4.27578 14.9008 3.79203 14.3045 3.79203Z" fill="white"/>
              </g>
              <defs>
              <clipPath id="clip0_302_1081">
              <rect width="18" height="18" fill="white" transform="translate(0.5 0.675781)"/>
              </clipPath>
              </defs>
            </svg>   
          </a>
        </li>
        <li>
          <a :href="linkedInUrl" title="LinkedIn" target="_blank" rel="noopener noreferrer">
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_302_1085)">
              <path d="M4.235 3.30078C4.235 4.33653 3.4025 5.17578 2.375 5.17578C1.3475 5.17578 0.515 4.33653 0.515 3.30078C0.515 2.26578 1.3475 1.42578 2.375 1.42578C3.4025 1.42578 4.235 2.26578 4.235 3.30078ZM4.25 6.67578H0.5V18.6758H4.25V6.67578ZM10.2365 6.67578H6.5105V18.6758H10.2372V12.3765C10.2372 8.87403 14.759 8.58753 14.759 12.3765V18.6758H18.5V11.0775C18.5 5.16753 11.8085 5.38278 10.2365 8.29203V6.67578Z" fill="white"/>
              </g>
              <defs>
              <clipPath id="clip0_302_1085">
              <rect width="18" height="18" fill="white" transform="translate(0.5 0.675781)"/>
              </clipPath>
              </defs>
            </svg>  
          </a>
        </li>
      </ul>
    </div>
    <div class="main-footer__col">
      <FooterMenu name="footer-menu-2" />
      <span class="main-footer__copyright">&copy; Ore Design {{ new Date().getFullYear() }}</span>
    </div>
  </div>
  </footer>
</template>

<script>

import FooterMenu from './FooterMenu.vue'

export default {
  name: 'footerModule',
  components: {
    FooterMenu
  },
  computed: {
    linkedInUrl() {
      const acfOptions = this.$store.getters.acfOptions()
      return acfOptions && acfOptions.linkedin ? acfOptions.linkedin : '#'
    },
    instagramUrl() {
      const acfOptions = this.$store.getters.acfOptions()
      return acfOptions && acfOptions.instagram ? acfOptions.instagram : '#'
    },
    footerLede() {
      const acfOptions = this.$store.getters.acfOptions()
      return acfOptions && acfOptions.footer_lede ? acfOptions.footer_lede : 'We design metal elements and systems for landscape architects and contractors. Our work is engineered for flawless functionality and designed to captivate, for any site condition or design intent.'
    },
    footerCtaButton() {
      const acfOptions = this.$store.getters.acfOptions()
      return acfOptions && acfOptions.footer_cta_button ? acfOptions.footer_cta_button : null
    }
  }
}
</script>